import { Address } from '@grubhubprod/order-taking-client-sdk/src/sdk/types/geocode';
import { FormFields } from 'src/components/enterprise/features/Locations/ManageLocation/LocationForm';
import { ILocation } from 'src/types/Location';
import { getFieldValue } from './getFieldValue.utils';

export function createNewLocationObject(
  fields: FormFields,
  suggestedAddress: Address
): Partial<ILocation> {
  return {
    ...fields,
    street_address1: getFieldValue(suggestedAddress, fields, 'street_address1'),
    address_locality: getFieldValue(
      suggestedAddress,
      fields,
      'address_locality',
      'address_sublocality'
    ),
    address_region: getFieldValue(suggestedAddress, fields, 'address_region'),
    postal_code: getFieldValue(suggestedAddress, fields, 'postal_code'),
    latitude: getFieldValue(suggestedAddress, fields, 'latitude'),
    longitude: getFieldValue(suggestedAddress, fields, 'longitude'),
    address_country: 'US',
  };
}
